<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <div class="vx-row pt-2">
        <vs-button size="small" class="mr-2 px-3" color="primary" type="filled" icon-pack="feather" icon="icon-move" @click="moveToCashBook"></vs-button>
        <vs-button size="small" class="mr-2 px-3" color="success" type="filled" icon-pack="feather" icon="icon-edit" @click="editRecord"></vs-button>
        <vs-button size="small" class="px-3" color="danger" type="filled" icon-pack="feather" icon="icon-trash" @click="confirmDeleteRecord"></vs-button>
      </div>
    </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'CellRendererActions',
  methods: {
    editRecord () {
      this.$router.push(`/cash-book-temporary/edit/${this.params.data.id}`).catch(() => {})
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Perhatian',
        text: `Anda akan menghapus "${this.params.data.id}" ?`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    deleteRecord () {
      const self = this
      this.$store.dispatch('cashBookTemporary/deleteCashBookTemporary', this.params.data.id)
        .then(function () {
          self.params.getCashBookTemporary()
          self.showDeleteSuccess()
        })
        .catch(err => {
          this.$vs.notify({
            color: 'danger',
            title: 'Opps..',
            text: err
          })
        })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'Berhasil',
        text: 'Bon Sementara terpilih berhasil dihapus'
      })
    },
    moveToCashBook () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Perhatian',
        text: `Anda akan memindahkan "${this.params.data.id}" ?`,
        accept: this.moveRecord,
        acceptText: 'Pindahkan'
      })
    },
    moveRecord () {
      const self = this
      
      const formData = Object.assign(this.params.data, {
        date_out: moment().format('DD-MM-YYYY'),
        balance: parseInt(this.params.data.balance.replaceAll(',', ''))
      })

      this.$store.dispatch('cashBookTemporary/updateCashBookTemporary', {
        id: this.params.data.id,
        data: formData
      })
        .then(function () {
          self.params.getCashBookTemporary()
          self.$vs.notify({
            color: 'success',
            title: 'Berhasil',
            text: 'Bon Sementara terpilih berhasil dipindahkan'
          })
        })
        .catch(err => {
          this.$vs.notify({
            color: 'danger',
            title: 'Opps..',
            text: err
          })
        })
    }
  }
}
</script>
